import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pathname, setPathname] = useState(window.location.pathname);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", handleScroll);

        const handlePathChange = () => {
            setPathname(window.location.pathname);
        };
        window.addEventListener("popstate", handlePathChange);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("popstate", handlePathChange);
        };
    }, []);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
    ];

    const leftLinks = navLinks.slice(0, 2);
    const rightLinks = navLinks.slice(2);

    return (
        <header
            className={`
        fixed top-0 left-0 w-full z-50
        transition-all duration-500
        ${scrolled
                    ? "bg-white/80 backdrop-blur-md shadow-md"
                    : "bg-white"}
      `}
        >
            {/* Linha animada */}
            <motion.div
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                className="
          origin-center
          h-[2px]
          w-full
          bg-blue-600
        "
            />

            <div className="relative flex items-center justify-center px-8 py-4">
                {/* Logo central */}
                <motion.a
                    href="/"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.4 }}
                    className="z-10"
                >
                    <img
                        src="/logo.png"
                        alt="Logo Julio Motors"
                        className={`transition-all duration-300 ${scrolled ? "h-24" : "h-32" 
                            }`}
                    />
                </motion.a>

                {/* Menu Mobile */}
                <div className="md:hidden absolute right-6 z-20">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="text-3xl text-gray-700"
                    >
                        {menuOpen ? <HiX /> : <HiMenu />}
                    </button>
                </div>

                {/* Navegação esquerda */}
                <nav className="hidden md:flex absolute left-8 top-1/2 -translate-y-1/2">
                    <ul className="flex gap-8 font-semibold text-gray-700">
                        {leftLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    className={`relative transition-colors ${pathname === link.href ? "text-blue-600" : ""
                                        }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* Navegação direita */}
                <nav className="hidden md:flex absolute right-8 top-1/2 -translate-y-1/2">
                    <ul className="flex items-center gap-8 font-semibold text-gray-700">
                        {rightLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    className={`relative transition-colors ${pathname === link.href ? "text-blue-600" : ""
                                        }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}

                        <Link
                            to="/contato"
                            className="
                ml-4
                px-5 py-2
                border border-blue-600
                text-blue-600
                rounded-full
                hover:bg-blue-600 hover:text-white
                transition
              "
                        >
                            Fale Conosco
                        </Link>
                    </ul>
                </nav>
            </div>

            {/* Mobile menu */}
            {menuOpen && (
                <div className="md:hidden bg-white shadow-lg px-6 py-4">
                    <ul className="flex flex-col gap-4 font-semibold text-gray-700">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className="block"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
